import React from 'react';
import {Dialog, DialogTitle, DialogContent, DialogActions} from '@material-ui/core';
import {Button} from '../index';
import {connect} from "react-redux";

class ConfirmDialog extends React.Component {
    render() {
        const {open, title, content, onAgree, onCancel, agreeText, cancelText, agreeLoading, cancelLoading, locale} = this.props;
        const pageTranslates = locale.translation.Components.Dialog;

        return (
            <Dialog open={open}>
                <DialogTitle id="form-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent style={{textAlign: 'right'}}>
                    {content}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancel} type='danger' classes='ml-2' loading={cancelLoading}>
                        {cancelText || pageTranslates.Cancel}
                    </Button>
                    <Button onClick={onAgree} type='success' loading={agreeLoading}>
                        {agreeText || pageTranslates.Approve}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(ConfirmDialog);

